export const actionTypes = {
    SET_MULTICHART_CONFIG: 'operationalParameters_v2/SET_MULTICHART_CONFIG',
    GET_MULTI_TREND_DATA: 'operationalParameters_v2/GET_MULTI_TREND_DATA',
    CLEAR_MULTICHART_DATA: 'operationalParameters_v2/CLEAR_MULTICHART_DATA'
};

export const excludedFromStandard = ['Torque', 'EnergyConsumption'];
export const includedFromAdditional = ['01.10', '01.11'];

export const SignalNames = {
    POWER: 'power',
    ENERGY: 'energyConsumption'
};
